// `name` of the backend SmsSessionAlreadyOpenError: AppSync delivers it as a top-level `errorType`
// (not under `extensions`); the owner's friendly id rides in the message.
const SMS_SESSION_ALREADY_OPEN_ERROR_TYPE = 'SmsSessionAlreadyOpenError';

const FRIENDLY_CONVERSATION_ID_IN_TEXT = /\b\d+-\d+\b/;

interface GraphQLErrorLike {
  message?: string;
  errorType?: unknown;
}

export function parseSmsSessionAlreadyOpenError(error: unknown): string | null {
  const graphQLErrors = (error as { graphQLErrors?: GraphQLErrorLike[] } | null)
    ?.graphQLErrors;
  const match = graphQLErrors?.find(
    (graphQLError) => graphQLError.errorType === SMS_SESSION_ALREADY_OPEN_ERROR_TYPE,
  );
  return match?.message?.match(FRIENDLY_CONVERSATION_ID_IN_TEXT)?.[0] ?? null;
}
